import {Component, Input, ElementRef, OnChanges, SimpleChanges, Output, EventEmitter, OnDestroy} from '@angular/core';
import {Dealer} from '@ox/typings';
import {DealerMapService} from '../../dealer-map/dealer-map.service';
@Component({
  selector: 'webu-dealer-info',
  templateUrl: './dealer-info-webu.component.html'
})
export class DealerInfoWithMapWebuComponent implements OnChanges, OnDestroy {

  @Input() dealer: Dealer;
  @Input() cmsPrefix: string;
  @Input() trackLinkPrefix: string;
  @Input() prop10Prefix: string;

  @Output() viewDirectionsChange = new EventEmitter();

  public isFirefox = navigator.userAgent.indexOf('Firefox') > 0;
  public mapElement: HTMLElement;
  public map: any;

  constructor(
    private element: ElementRef,
    private dealerMapService: DealerMapService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['dealer']?.currentValue) {
      this.onDealerChanged();
    }
  }

  ngOnDestroy() {
    this.viewDirectionsChange.complete();
  }

  onDealerChanged() {
    if (!this.map) {
      this.mapElement = this.element.nativeElement.querySelector('.js-dealer-map-canvas');
      this.map = this.dealerMapService.DealerMap(this.mapElement);
    }
    // Ignore invalid dealers
    if (!this.dealer || !this.dealer.id) throw new Error();

    this.dealerMapService.mapMarker(this.dealer, this.map).subscribe({
      error: (err) => {
        console.warn('Dealer Standard Info Map: Failed to initialize the map. ', err);
      }
    });
  }

  goToDealerDirections() {
    this.viewDirectionsChange.emit('directions');
  }

  loadOss(){
    const URL = this.dealer.scheduleServiceWebSite;
    window.location.href = URL;
  }

  printDealerInfo() {
    const $windowScope = {
      widget: {
        dealer: {...this.dealer}
      },
      directions: {
        dealerAddress: this.dealer.address,
        startingAddress: ''
      }
    };
    window.open('../preferredDealer/print', '_blank');
    window.$windowScope = $windowScope;
  }
}
